import React from 'react';
import './Loader.css';

function Loader() {
    return (
        <div id="background">
            <div id="loader">
                <div id="box"></div>
                <div id="hill"></div>
            </div>
        </div>
    )
}

export default Loader
